import { UserStatusMenu } from '../UserStatusMenu';
import useFurthestTask from './useFurthestTask';

const UserStatusMenuWithFurthestTask = () => {
  const { furthestWrapUpTask } = useFurthestTask();

  return (
    <UserStatusMenu
      key={furthestWrapUpTask?.id}
      furthestWrapUpTask={furthestWrapUpTask ?? undefined}
    />
  );
};

export default UserStatusMenuWithFurthestTask;
